import { render, staticRenderFns } from "./CommunityUnitBusinessNewsReply.vue?vue&type=template&id=3c6ae078&"
import script from "./CommunityUnitBusinessNewsReply.vue?vue&type=script&lang=js&"
export * from "./CommunityUnitBusinessNewsReply.vue?vue&type=script&lang=js&"
import style0 from "./CommunityUnitBusinessNewsReply.vue?vue&type=style&index=0&id=3c6ae078&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports